import roller from '!!raw-loader!../assets/roller.part.html';
import { Options } from './types/Options';

const getDocument = () => document;
const getDocumentBody = () => getDocument().body;
const oa = Object.assign as <T>(obj: T, props: Partial<T>) => T;
const dce = getDocument().createElement.bind(getDocument());
const scriptElement = getDocument().currentScript as HTMLScriptElement;
const hiddenFrameClassName = '__c5__hidden';

if (!scriptElement) {
  throw new Error('Could not load Communi5 WebWidget');
}

const publicPath = scriptElement.src.replace(/loader\.js$/, '');

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
__webpack_require__.p = publicPath;

import ('./loader.communication.webwidget') // load communication asynchronously
  .then(({ init }) => init({ hideFrame }));

import('./assets/webwidget.loader.global.scss')
  .then(() => {
    webWidgetFrame.style.display = '';
    webWidgetButton.style.display = '';
  });

const {
  options,
  c5id,
  c5token,
} = scriptElement.dataset;

const opts: Partial<Options> = {
  withButton: true,
  withDefaultFrameStyles: true,
};

try {
  const customOpts = JSON.parse(options || '{}');
  oa(opts, customOpts);
} catch (e) {
  console.error(
    'Could not parse data-options param. Please check if it is a valid json.',
    e,
  );
}

const frameUrlParams = new URLSearchParams({
  c5id,
  c5token,
  embedded: '1',
  options: JSON.stringify(opts),
} as Record<string, string>);

const hideFrame = () => {
  webWidgetFrame.classList.add(hiddenFrameClassName);
  webWidgetRoller?.classList.add(hiddenFrameClassName);
}

const showFrame = () => {
  loadWebFrame();
  webWidgetFrame.classList.remove(hiddenFrameClassName);
  webWidgetRoller?.classList.remove(hiddenFrameClassName);
}

const toggleFrame = () => {
  if (webWidgetFrame.classList.contains(hiddenFrameClassName)) {
    showFrame();
  } else {
    hideFrame();
  }
}

let isLoadStarted = false;
const loadWebFrame = () => {
  if (isLoadStarted) return;
  webWidgetFrame.src = `${publicPath}frame.html?${frameUrlParams.toString()}`;
  webWidgetFrame.addEventListener('load', () => {
    webWidgetRoller?.remove();
    webWidgetRoller = undefined;
  }, { once: true });
  isLoadStarted = true;
}

const webWidgetButton = oa(
  dce('div'),
  {
    className: '__c5__web-widget-button',
    innerHTML: '&#x1F4DE;',
    onclick: () => {
      loadWebFrame();
      toggleFrame();
    },
    onmouseover: loadWebFrame,
  }
);
webWidgetButton.style.display = 'none';

const frameStyles = (
  opts.withDefaultFrameStyles
    ? '__c5__web-widget-frame-default-style'
    : ''
) + ' __c5__web-widget-frame __c5__hidden';

const webWidgetFrame = oa(
  dce('iframe'),
  {
    allow: 'camera;microphone',
    className: frameStyles,
  }
);
webWidgetFrame.style.display = 'none';

let webWidgetRoller: HTMLDivElement | undefined = oa(
  dce('div'),
  {
    className: frameStyles,
    innerHTML: roller,
  }
);

const init = () => {
  if (opts.withButton) getDocumentBody().appendChild(webWidgetButton);
  getDocumentBody().appendChild(webWidgetFrame);
  getDocumentBody().appendChild(webWidgetRoller as HTMLDivElement);
};

if (getDocumentBody()) init();
else addEventListener('load', init, { once: true });

type WindowWithC5Methods = Window & typeof globalThis & {
  communi5: {
    hideFrame: typeof hideFrame,
    loadWebFrame: typeof loadWebFrame,
    showFrame: typeof showFrame,
    toggleFrame: typeof toggleFrame,
  }
}

oa<WindowWithC5Methods>(
  window as WindowWithC5Methods,
  { communi5: { hideFrame, loadWebFrame, showFrame, toggleFrame } },
);
